/** Which product surface is active — drives `data-portal` CSS token scopes. */
export type PortalTheme = "internal" | "client";

const CLIENT_PREFIX = "/client";

export function getPortalTheme(pathname: string): PortalTheme {
  return pathname === CLIENT_PREFIX || pathname.startsWith(`${CLIENT_PREFIX}/`)
    ? "client"
    : "internal";
}

export function applyPortalTheme(pathname: string): PortalTheme {
  const theme = getPortalTheme(pathname);
  document.documentElement.dataset.portal = theme;
  return theme;
}
